import loadable from '@loadable/component';
const modelsManifestPath = './src/models/models.manifest.ts';
export const manifest = {
  SmePersonalization: {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmePersonalization";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmePersonalization" */
          '.'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak(".");
            }

            return eval('require.resolve')(".");
          }

        }, {
          resolveComponent: m => m.SmePersonalization
        })
      }
    }
  },
  'SmePersonalization.Provider': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmePersonalizationProvider";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmePersonalizationProvider" */
          './provider'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./provider");
            }

            return eval('require.resolve')("./provider");
          }

        }, {
          resolveComponent: m => m.SmePersonalizationProvider
        })
      }
    }
  },
  'SmePersonalization.CloseBannerButton': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmePersonalizationCloseBannerButton";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmePersonalizationCloseBannerButton" */
          './close-banner-button'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./close-banner-button");
            }

            return eval('require.resolve')("./close-banner-button");
          }

        }, {
          resolveComponent: m => m.SmePersonalizationCloseBannerButton
        })
      }
    }
  }
};